import { render } from "./TextButton.vue?vue&type=template&id=0645552e&scoped=true"
import script from "./TextButton.vue?vue&type=script&lang=js"
export * from "./TextButton.vue?vue&type=script&lang=js"

import "./TextButton.vue?vue&type=style&index=0&id=0645552e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0645552e"]])

export default __exports__